import Http from '../commons/utils/Http'
import { errorHandling } from '../commons/utils/error'

class officesService {

    async getOfficesDeps(user_id) {
        try {
            let response = await Http.get(`/office/get-all-office-dep-by-user?id=${user_id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getOfficesUser(user_id) {
        try {
            let response = await Http.get(`/office/get-user-offices?id=${user_id}`,Http.headers)
            if (response.status == 204){
                return null;
            }
            return response
        } catch (e) {
            errorHandling(e)
        }
    }


    async insert(data) {
        try {
            let response = await Http.post(`/office`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async inactivate(data) {
        try {
            let response = await Http.put(`/office/inactivate-user-office`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

}

export default new officesService();